import React from 'react'

import {
  TextInput,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function Input({ handleChange, locale = 'en' }) {
  const inputPlaceholder = i18n.t('listingPage.footerBanners.searchSubscription.inputPlaceholder',
    { ns: 'rails', lng: locale })

  return (
    <TextInput
      id="search-subscription-description"
      isPilot
      type="ghost"
      size="medium"
      handleChange={handleChange}
      inputType="text"
      wrapperClassName="cgt-form-element-wrapper--fluid"
      textInputClassName="search-subscription__description-input"
      placeholder={inputPlaceholder}
    />
  )
}

Input.propTypes = {
  handleChange: func.isRequired,
  locale: string,
}

export default Input
